import styled from 'styled-components'

const StyledAuthDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  padding: 20px;
  box-sizing: border-box;
  display: grid;
  align-items: center;
  justify-content: center;

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.8);
  }

  .dialog {
    position: relative;
    box-sizing: border-box;
    padding: 34px;
    max-width: 470px;
    width: 100vw;
    background-color: ${({ theme }) => theme.color.background};
    border-radius: 10px;
    overflow: hidden;
    overflow-y: auto;
    max-height: 100%;

    .icon {
      height: 60px;
      width: 60px;
      border-radius: 50%;
      display: flex;
      margin: 0 auto 28px auto;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.color.background};
      background-color: ${({ theme }) => theme.color.gray[900]};

      svg {
        height: 28px;
      }
    }

    .title {
      font-weight: 600;
      font-size: 20px;
      display: block;
      text-align: center;
    }

    .description {
      text-align: center;
      display: block;
      margin-top: 6px;
      font-size: 15px;
      color: ${({ theme }) => theme.color.gray[500]};
    }

    form {
      margin-top: 34px;

      .auth-btn {
        height: 55px;
        width: 100%;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        transition: 0.2s;
        text-decoration: none;

        svg {
          height: 24px;
          margin-right: 12px;
        }
      }

      .register-form {
        .fields {
          display: grid;
          gap: 16px;
          margin-bottom: 28px;

          input {
            width: 100%;
            height: 55px;
            border-radius: 8px;
            padding: 0 16px;
            box-sizing: border-box;
            transition: 0.2s;
            border: 1px solid ${({ theme }) => theme.color.gray[300]};
            background-color: ${({ theme }) => theme.color.background};
            color: ${({ theme }) => theme.color.gray[800]};

            &::placeholder {
              color: ${({ theme }) => theme.color.gray[400]};
            }

            &:focus {
              box-shadow: 0 0 0 3px ${({ theme }) => theme.color.gray[200]};
              border-color: ${({ theme }) => theme.color.gray[600]};
            }
          }
        }

        .register-btn {
          background-color: transparent;
          color: ${({ theme }) => theme.color.gray[900]};
          box-shadow: inset 0 0 0 1px ${({ theme }) => theme.color.gray[900]};

          &:hover {
            background-color: ${({ theme }) => theme.color.gray[200]};
          }

          &:focus-visible {
            box-shadow: inset 0 0 0 1px ${({ theme }) => theme.color.gray[900]},
              0 0 0 3px ${({ theme }) => theme.color.gray[200]};
          }
        }
      }

      .or-sep {
        margin: 30px 0;
        height: 1px;
        position: relative;
        background-color: ${({ theme }) => theme.color.gray[300]};

        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 13px;
          font-weight: 500;
          padding: 0 10px;
          background-color: ${({ theme }) => theme.color.background};
          color: ${({ theme }) => theme.color.gray[500]};
        }
      }

      .login-btn {
        background-color: #2f40f8;
        color: ${({ theme }) => theme.color.background};

        &[aria-disabled='true'] {
          pointer-events: none;
        }

        &:hover {
          background-color: #1c2cd9;
        }
      }
    }
  }
`

export default StyledAuthDialog
